import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { TAIError, TAIResponse, TAIState, TMessage } from "../types/ai.types";
import { aiApi, ChatMessage } from "../api/ai.api";

const initialState: TAIState = {
  messages: [],
  error: null,
  initialRequest: {},
};
const storeAIAnswer = (state: TAIState, action: PayloadAction<TAIResponse>) => {
  const newReplyContent = action.payload.reply;
  if (newReplyContent) {
    state.error = null;
    const now = new Date();
    const date = now.toLocaleDateString();
    const time = now.toLocaleTimeString();
    state.messages.push({
      role: "assistant",
      content: newReplyContent,
      date: date,
      time: time,
    });
  } else {
    state.error = "Received an empty or invalid response from the server.";
  }
};
export const aiSlice = createSlice({
  name: "ai",
  initialState,
  reducers: {
    addMessage(state, action: PayloadAction<TMessage>) {
      state.messages.push(action.payload);
    },
    setAIMessages(state, action: PayloadAction<ChatMessage[]>) {
      state.error = null;
      state.messages = action.payload
        .filter((msg) => msg.role !== "system")
        .map((msg) => {
          const now = new Date();
          const date = now.toLocaleDateString("he-IL");
          const time = now.toLocaleTimeString("he-IL", {
            hour: "2-digit",
            minute: "2-digit",
          });
          return {
            role: msg.role as "user" | "assistant",
            content: msg.content,
            date,
            time,
          };
        });
    },
    clearMessages(state) {
      state.error = null;
      state.messages = [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addMatcher(
        aiApi.endpoints.getResponseFromAI.matchFulfilled,
        storeAIAnswer
      )
      .addMatcher(
        aiApi.endpoints.getResponseFromVoiceAI.matchFulfilled,
        storeAIAnswer
      )
      .addMatcher(
        aiApi.endpoints.getResponseFromAI.matchRejected,
        (state: TAIState, { payload }) => {
          if (payload) {
            state.error = (payload as unknown as TAIError).message;
          } else {
            state.error = "משהו השתבש, אנא נסה שוב מאוחר יותר";
          }
        }
      )
      .addMatcher(
        aiApi.endpoints.getResponseFromVoiceAI.matchRejected,
        (state: TAIState, { payload }) => {
          if (payload) {
            state.error = (payload as unknown as TAIError).message;
          } else {
            state.error = "משהו השתבש, אנא נסה שוב מאוחר יותר";
          }
        }
      );
  },
});

export const { actions, reducer } = aiSlice;
export default reducer;
